module.exports = __webpack_public_path__ + "static/media/about.1e69c5c0.png";